import {
    Component,
    ContentChild,
    TemplateRef,
    Optional,
    Input
} from '@angular/core';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { RightSidebarComponent } from '../RightSidebar/right-sidebar.component';

export enum ActionBarContextEnum {
    default,
    rightSidebar
}
@Component({
    selector: 'agpr-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['./action-bar.component.scss'],
    standalone: false
})
export class ActionBarComponent {

    @Input() id: string;
    @Input() headingContext: string;
    @Input() headingLevel: number = 3;
    @Input() warningBar: boolean = false;

    @ContentChild('top') top: TemplateRef<any>;
    @ContentChild('left') left: TemplateRef<any>;
    @ContentChild('right') right: TemplateRef<any>;

    context: ActionBarContextEnum = ActionBarContextEnum.default;

    readonly contexts = ActionBarContextEnum;
    readonly agprComponentStyleEnum = AgprComponentStyleEnum;

    constructor(
        @Optional() private parentRHP: RightSidebarComponent
    ) {
        if (this.parentRHP) {
            this.context = ActionBarContextEnum.rightSidebar;
        }
    }
}
